import { createTheme } from '@mui/material/styles';

// Kept intentionally simple and separate from the main app's theme — this
// is its own project with its own build, so there's nothing to keep in
// sync here beyond a similar accent color for brand consistency.
const theme = createTheme({
  palette: {
    primary: {
      main: '#0b5394',
    },
    secondary: {
      main: '#38761d',
    },
  },
  shape: {
    borderRadius: 8,
  },
});

export default theme;
